/**
 * Decides whether the create forms should send a `cardProduct` at all.
 *
 * A `cardProduct` must only be sent when the user entered card settings. Otherwise the server rejects the
 * request (e.g. `cardQualifier should be string`), because an empty card object is not valid.
 *
 * - Every card field starts as `null` on a fresh form, so "any field is non-null" means the user entered something.
 * - `untouchedDefaults` lists fields that a fresh form pre-fills with a non-null value (e.g. the max number of
 *   cards is 0 for Unit Pilot orgs). A field still holding its untouched default is not user input. Pass it only
 *   for a brand new form, never when duplicating, where the pre-filled values are meant to be sent.
 * - Callers must pass only real card fields. Top-level attributes that merely render inside the Cards card
 *   (e.g. `additionalVerificationThreshold`) must not be passed.
 */
export function hasCardProductInput(
	cardFields: Record<string, unknown>,
	untouchedDefaults: Record<string, unknown> = {}
): boolean {
	return Object.entries(cardFields).some(
		([field, value]) => value != null && !(field in untouchedDefaults && value === untouchedDefaults[field])
	)
}
